module.exports = __webpack_public_path__ + "img/mam-trim-poster-00001.767c3348.jpg";